import type {
  FindUserTravelersOutputData,
  FindHotelOffersRoom,
  FindHotelOffersPackageRoomOption,
} from "@/types/codegen";
import type { SortValue } from "@/types/types";

export type {
  InitiateHotelsSearchOutputData as HotelSearchTokens,
  FindHotelsHotelItemV2 as HotelData,
  FindHotelOffersOutputData as HotelOffer,
  FindHotelOffersRoom as HotelOfferRoom,
} from "@/types/codegen";

export type TRoom = {
  adults: number;
  children: number;
  childrenAges: number[];
};

export type THotelSearchResult = {
  id: number | string;
  name: string;
  address: string;
  specialDeal?: boolean;
  recommended?: boolean;
  descriptions?: {
    short: string;
    full: string;
    location: string;
    facilities: string;
    rooms: string;
    essentialInformation: string;
  };
  boardBasis?: string[];
  stars: number;
  mainImageUrl: string;
  imagesUrls: string[];
  telephone?: string;
  email?: string;
  fax?: string;
  minPrice?: {
    value: number;
    currency: string;
  };
  geolocation?: {
    latitude: number;
    longitude: number;
  };
};

export type THotelRoom = {
  name: string;
  board: string;
} & FindHotelOffersRoom;

export type TRoomOutput = {
  packageRoomToken: string;
  travelers: FindUserTravelersOutputData[];
};

export interface Price {
  value: number;
  currency: string;
}

export type HotelBookingRoomOption = FindHotelOffersPackageRoomOption;

export interface HotelBooking {
  packageToken: string;
  offerId: string;
  rooms: HotelBookingRoomOption[];
}

export type HotelsSortValue = SortValue<HotelsSortOptions>;

export interface IHotelsFilters {
  minPrice?: number;
  maxPrice?: number;
  priceRange: [number, number];
  boardBasis?: string[];
  starRating: number[];
}

export enum HotelsSortOptions {
  PRICE = "price",
  RATING = "stars",
  RECOMMENDED = "recommended",
  SPECIALDEAL = "specialDeal",
}

export enum TravelPurpose {
  LEISURE = "leisure",
  BUSINESS = "business",
}

export type RoomImage = NonNullable<HotelBookingRoomOption["images"]>[number];

export type RoomCombinationGroup = {
  id: string;
  displayName: string;
  combinations: RoomCombination[];
  minPrice: number;
};

export type RoomCombination = {
  id: string;
  boardBasis: string;
  isRefundable: boolean;
  totalPrice: number;
  currency: string;
  rooms: HotelBookingRoomOption[];
};
